import React from "react";
import Select from "react-select";
import "../segment.css";
import { useEffect, useRef, useState } from "react";
import { IMetaData, IFilterDef, FilterDef, IExpression, IFilter, IRule, FilterUtils } from "../../../../services/SegmentService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCross, faList, faListCheck, faListOl, faPlus, faTachometerAlt, faThumbsDown, faXmark, faXmarkSquare } from "@fortawesome/free-solid-svg-icons";
import { boolean } from "yup";
import { RuleDetailProps, styles } from "./CustomerRuleDetail";
import { set } from "lodash";
import { faClock } from "@fortawesome/free-regular-svg-icons";


export const EventRuleDetail = ({ rule, filterDef, segmentMeta, changeRuleData }: RuleDetailProps) => {

    const periodUnitOpts = [
        { label: "Hours", value: "HOUR" },
        { label: "Days", value: "DAY" },
        { label: "Weeks", value: "WEEK" },
        { label: "Months", value: "MONTH" }
      ];
    
    const [ex, setEx] = useState<IExpression | null>(null);
    const [unitEx, setUnitEx] = useState<IExpression | null>(null);
    const [where, setWhere] = useState<any>({
        operand: rule.data?.where.filter(w => w.expressionKey != "_unit")[0]?.operand ?? null,
        value: rule.data?.where.filter(w => w.expressionKey != "_unit")[0]?.value ?? null,
        expressionKey: rule.data?.where.filter(w => w.expressionKey != "_unit")[0]?.expressionKey ?? null
    });

    const [unitWhere, setUnitWhere] = useState<any>({
        operand: rule.data?.where.filter(w => w.expressionKey == "_unit")[0]?.operand ?? null,
        value: rule.data?.where.filter(w => w.expressionKey == "_unit")[0]?.value ?? null,
        expressionKey: rule.data?.where.filter(w => w.expressionKey == "_unit")[0]?.expressionKey ?? "_unit"
    });

    const [period, setPeriod] = useState<any | null>({
        type : rule.data?.period?.type ?? "last", 
        unit : rule.data?.period?.unit ?? null, 
        value : rule.data?.period?.value ?? null});

    //const [relPeriodFlag, setRelPeriodFlag] = useState<boolean>(false); //false means last, true means since

    const relPeriodFlag = () => period.type == "since";

    useEffect(() => {

        const expression = rule.data.filterDef?.expressions.find(e => e.key == where.expressionKey)!;
        const expressionKey = expression ? expression.key : null;

        setEx(expression);
        setWhere({
            ...where,
            expressionKey: expressionKey
        });

        const unitExpression = rule.data.filterDef?.expressions.find(e => e.key == unitWhere.expressionKey)!;
        const unitExpressionKey = unitExpression ? unitExpression.key : null;

        setUnitEx(unitExpression);
        setUnitWhere({
            ...unitWhere,
            expressionKey: unitExpressionKey
        });

    }, [rule.data.filterDef]);

    useEffect(() => {

        updateParent();

    }, [where, unitWhere, period]);

    useEffect(() => {
        if(!isPeriodValid()) {
            alert("Months should be less than 12");
        }

        updateParent();

    }, [period]);

    const updateParent = () => {

        changeRuleData(rule, {
            segmentMeta: segmentMeta,
            where: [where, unitWhere],
            filterDef: filterDef,
            period: period
        });
    }

    const operandChange = (e) => {
        setWhere({
            ...where,
            operand: e?.value
        });
    }

    const valueChange = (v) => {

        setWhere({
            ...where,
            value: v
        });
    }

    const expressionChange = (e) => {

        const _ex = filterDef.expressions.find(_e => _e.key == e?.value)!;
        setEx(_ex);
        setWhere({
            operand: null,
            expressionKey: _ex?.key,
            value: null
        });
    }

    const unitValueChange = (v) => {
        setUnitWhere({
            ...unitWhere,
            value: v
        });
    }

    const unitOperandChange = (e) => {
        setUnitWhere({
            ...unitWhere,
            operand: e?.value
        });
    }

    const isPeriodValid = () => {

        if(period == null) {
            return true;
        }

        if(period.type == "last") {
            if(period.unit == "months" && period.value != null && Number(period.value) > 12) {
                return false;
            } 
            return true;
        } 

        return true;
    }

    const periodChange = (p) => {
        setPeriod(p);
    }


    const renderRuleDetail = () => {

        let filterDefDetail;
        let filterDefOperand;
        let filterDefOption;
        let filterDuration;
        let subFilterDef;
        let unitExpDef;
        let periodDef;

        //New Rule
        if (filterDef) {



            subFilterDef =
                <Select className="col-sm-3"
                    onChange={e => expressionChange(e)}
                    options={filterDef.expressions.filter(e => e.key != "_unit").map(e => ({ "label": e.readableName, "value": e.key }))}
                    value={ex ? { "label": ex.readableName, "value": ex.key } : undefined}
                    styles={styles}
                />

            if (ex?.key != "any") {


                filterDefOperand =
                    <Select className="col-sm-3" options={ex?.opList.map(o => ({ "label": o, "value": o }))}
                        onChange={e => operandChange(e)}
                        placeholder="Operation" value={where.operand ? { label: where.operand, value: where.operand } : undefined}
                        styles={styles}
                    />

                if (ex?.options && ex.options.length > 0) {
                    let selectedVal = rule.ruleId ? ex?.options.filter(o => o.key == where.value).map(o => {
                        return {
                            label: o.readableName,
                            value: o.key
                        }
                    })[0]! : undefined;

                    filterDefOption =
                        <Select className="col-sm-4" onChange={e => valueChange(e?.value)}
                            options={ex.options.map(o => ({ "label": o.readableName, "value": o.key }))}
                            value={selectedVal} placeholder="Choose a value"
                            styles={styles}
                        />
                } else {
                    filterDefOption =
                        <div className="col-sm-3">
                            <input className="form-control" placeholder="e.g 'sample'" onChange={e => valueChange(e.target.value)} type="text" value={where.value ? where.value : undefined}></input>
                        </div>
                }
            } else {
                filterDefOperand = <></>
                filterDefOption = <></>
            }

            unitExpDef =
                <>
                    <div className="col-sm-3 mt-2">
                        <span>
                             with frequency of
                            <span className="ml-2 badge badge-light text-body">
                                <FontAwesomeIcon icon={faListOl} />
                            </span>
                        </span>
                    </div>
                    <Select className="col-sm-3"
                        options={unitEx?.opList.map(o => ({ "label": o, "value": o }))}
                        onChange={e => unitOperandChange(e)}
                        value={rule.ruleId ? { label: unitWhere.operand, value: unitWhere.operand } : undefined}
                        placeholder="Choose..."
                        styles={styles}
                    />
                    <div className="col-sm-3">
                        <input className="form-control" placeholder="e.g more than 1" type="number" min="1" step="1"
                            onChange={e => unitValueChange(e.target.value)}
                            value={unitWhere.value ? unitWhere.value : undefined}>
                        </input>
                    </div>
                </>


            periodDef =
            <>
                <div className="col-sm-3 mt-2">
                    <span>
                        period of
                        <span className="ml-2 badge badge-light text-body">
                            <FontAwesomeIcon icon={faClock} />
                        </span>
                    </span>
                </div>
                <Select className="col-sm-3"
                    options = {["Last", "Since"].map(o => ({ "label": o, "value": o.toLowerCase() }))}
                    onChange={e => {
                            periodChange({type : e?.value, unit : null, value : null});
                        }
                    }
                    value = {relPeriodFlag() ? { "label": "Since", "value": "Since" } : { "label": "Last", "value": "Last" }}
                    styles={styles}
                />
                {relPeriodFlag() 
                    ?
                        <div className="col-sm-3">
                            <input 
                                className="form-control" 
                                onChange={e => periodChange({...period, value: e.target.value})} 
                                placeholder="e.g 1" 
                                type="date" 
                                value={period.value ? period.value : ""} 
                                pattern="\d{4}-\d{2}-\d{2}"
                                onBlur={e => {
                                    const date = new Date(e.target.value);
                                    if (!isNaN(date.getTime())) {
                                        const formattedDate = date.toISOString().split('T')[0];
                                        periodChange({...period, value: formattedDate});
                                    }
                                }}
                            />
                        </div>
                    :
                        <>
                            <Select className="col-sm-3"
                                options = {periodUnitOpts}
                                placeholder = "Choose..."
                                styles={styles}
                                onChange={e => periodChange({...period, unit : e?.value, value : null})}
                                value={period.unit ? periodUnitOpts.filter(p => p.value == period.unit)[0] : undefined}
                            />
                            <div className="col-sm-3">
                                <input 
                                    className={`form-control ${!isPeriodValid() ? "is-invalid" : ""}`} placeholder="e.g 1" type="number" min="1" step="1"
                                    onChange={e => periodChange({...period, value : e.target.value})}
                                    value={period.value ? period.value : ""}
                                >
                                </input>
                            </div>
                        </>
                    }
                
            </>    
            
            filterDefDetail =
                <div className="col-sm-8">
                    <div className="row">
                        {subFilterDef}
                        {filterDefOperand}
                        {filterDefOption}
                        {filterDuration}
                    </div>
                    <div className="row mt-4">
                        {unitExpDef}
                    </div>
                    <div className="row mt-4">
                        {periodDef}
                    </div>
                </div>

        } else {
            filterDefDetail =
                <div className="col-sm-8">
                    <div className="row">
                    </div>
                </div>
        }

        return filterDefDetail;
    }


    return (
        <>
            {renderRuleDetail()}
        </>
    );

}